jQuery($ => {
    class GeolocationTrigger {
      constructor(element) {
        this._        = element;
        this._element = $(element);

        this._storageKeyPrefix = LOCAL_STORAGE.user_location.key_prefix;
        this._storageKeys      = LOCAL_STORAGE.user_location.keys;
  
        this.init();
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Initialize
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      init() {
        this.setupHandlers();
        this._element.trigger( 'geolocation-trigger:init', this );
      }
  
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Setup Handlers
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
      setupHandlers() {
        this._element.on('click', this.handleClick);
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Click
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleClick = () => {
        this.requestBrowserLocation();
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Request Browser Location
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      requestBrowserLocation = () => {
        if (!navigator.geolocation) {
          console.warn('Geolocation not available (insecure context?)');
          return;
        }

        const storedLocation = this.checkLocalStorage();
        if (storedLocation) {
          this._element.trigger('geolocation-trigger:success', storedLocation);
          return;
        }

        navigator.geolocation.getCurrentPosition(
          (position) => {
            const lat = position.coords.latitude;
            const lng = position.coords.longitude;

            this._currentLat = lat;
            this._currentLng = lng;

            localStorage.setItem(this._storageKeys.lat, lat);
            localStorage.setItem(this._storageKeys.lng, lng);
            localStorage.setItem(this._storageKeys.type, 'precise');

            this.handleReverseGeocodeRequest(lat, lng);
          },
          (error) => {
            console.warn('Geolocation error:', error);
            this._element.trigger('geolocation-trigger:error', error);
          }
        );
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Check Local Storage
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      checkLocalStorage = () => {
        const type = localStorage.getItem(this._storageKeys.type);

        if (type != 'precise') return false;
        
        const lat = localStorage.getItem(this._storageKeys.lat);
        const lng = localStorage.getItem(this._storageKeys.lng);

        if (!lat || !lng) return false;

        return {
            lat: parseFloat(lat),
            lng: parseFloat(lng)
        };
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Update Local Storage
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      updateLocalStorage = (location) => {
        if (!location) return;

        Object.entries(location).forEach(([key, value]) => {
          if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
            Object.entries(value).forEach(([subKey, subValue]) => {
              localStorage.setItem(`${this._storageKeyPrefix}.${key}.${subKey}`, subValue);
            });
          } else {
            localStorage.setItem(`${this._storageKeyPrefix}.${key}`, value);
          }
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Reverse Geocode Request
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleReverseGeocodeRequest = (lat, lng) => {
        let data = {
          action: 'reverse_geocode_latlng',
          data: {
            lat,
            lng
          }
        }

        $.ajax({
          url: AJAX.url,
          type: 'POST',
          data,
          success: this.handleRequestResponse,
          error: (xhr, status, error) => {
            console.error('AJAX request failed:', { xhr, status, error });
            this.handleRequestError({ message: 'AJAX request failed' });
          }
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Request Response
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleRequestResponse = (response) => {
        const isSuccess = response.success === undefined || response.success;
        const data      = response.data || {};

        if (isSuccess) {
          this.handleRequestSuccess(data);
        } else {
          this.handleRequestError(data);
        }
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Request Success
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleRequestSuccess = (data) => {
        this.updateLocalStorage({
          lat: data.lat,
          lng: data.lng,
          city: {
            short: data.city.short_name,
            long : data.city.long_name
          },
          state: {
            short: data.state.short_name,
            long : data.state.long_name
          },
          zip: data.zip,
          country: {
            short: data.country.short_name,
            long : data.country.long_name
          },
          type: 'precise'
        });
        
        this._element.trigger('geolocation-trigger:success', { 
          lat: this._currentLat,
          lng: this._currentLng,
          ...data 
        });
      }

      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
      // ✅ Handle Request Error
      //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡

      handleRequestError = (data) => {
        console.error('Status: Reverse geocode ajax request failed', data);
        
        this._element.trigger('geolocation-trigger:error', { 
          lat: this._currentLat, 
          lng: this._currentLng,
          error: 'reverse_geocode_failed'
        });
      }
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Setup jQuery Plugin
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $.fn.geolocation_trigger = function() {
      var _ = this,
          opt = arguments[0],
          args = Array.prototype.slice.call(arguments, 1),
          l = _.length,
          i,
          ret;
      for (i = 0; i < l; i++) {
        if (typeof opt == 'object' || typeof opt == 'undefined')
          _[i].geolocation_trigger = new GeolocationTrigger(_[i], opt);
        else
          ret = _[i].geolocation_trigger[opt].apply(_[i].geolocation_trigger, args);
        if (typeof ret != 'undefined') return ret;
      }
      return _;
    }
  
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
    // ✅ Run
    //≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡≡
  
    $('.a-geolocation-trigger').geolocation_trigger();
});